import { IPropsTable } from '../interface';
import { $document } from '@umu/umu-dom';
const TABLE_SCROLL_CLS_STICKY = '.umu-design-comp-table-body';
const TABLE_SCROLL_CLS_NO_STICKY = '.ant-table-content';
const getTableConfig = <T extends object>(data: IPropsTable<T>) => {
    const { isVirtualScroll, mountElementCls = 'winter', sticky = false } = data;
    const bodyWidth = $document.body.clientWidth;
    const scrollWidth = $document.getElementsByClassName(mountElementCls)[0]?.clientWidth || bodyWidth;
    if (!isVirtualScroll) {
        return {
            tableConfig: {},
            viewsConfig: {},
            scrollWidth,
        };
    }

    return {
        tableConfig: {
            sticky: sticky,
            scroll: { x: scrollWidth },
        },
        viewsConfig: {
            style: { width: scrollWidth },
        },
        scrollWidth,
    };
};
export { TABLE_SCROLL_CLS_STICKY, TABLE_SCROLL_CLS_NO_STICKY, getTableConfig };
